import { IScreenOrderItem } from 'utils/buildFlowTransitions';

export const defaultScreenOrder: IScreenOrderItem[] = [
  {
    orderNumber: 1,
    pageName: 'PLATE_TO_VIN',
  },
  {
    orderNumber: 2,
    pageName: 'PROVE',
  },
  {
    orderNumber: 3,
    pageName: 'CREATE_CONTACT',
  },
  {
    orderNumber: 4,
    pageName: 'SOFT_PULL_LOAN',
  },
  {
    orderNumber: 5,
    pageName: 'ADDRESS',
  },
  {
    orderNumber: 6,
    pageName: 'EMPLOYMENT',
  },
  {
    orderNumber: 7,
    pageName: 'NEXT_STEPS',
  },
  {
    orderNumber: 8,
    pageName: 'OFF_RAMP',
  },
];
